import { IOrderRecapService } from "../IOrderRecapService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderRecapPromiseService implements IOrderRecapService {
  public abstract getOrderRecap(orderIds: any): Promise<Array<string>>;
}
